import React, { useState, useEffect } from "react"
import { getRoutesQuery, getLangFromPath } from "../../../utils"
import { TransitionProvider, TransitionViews } from "gatsby-plugin-transitions"
import { AnimatePresence, motion } from "framer-motion"
import GlobalStyle, { ApplicationWrapper, SmallTitle } from "./styles/styles"
import SideBar from "../sidebar/sidebar"
import ScrollTransition, {
  tranistionAnimations,
} from "../scrollTransition/scrollTransition"
import OldBrowser from "../oldBrowser/oldBrowser.jsx"
import Typography from "components/Typography"
import ScrollIcon from "../scrollIcon/scrollIcon"

const Layout = ({ location, path, children }) => {
  const [removeUI, setRemoveUI] = useState(true)
  const [chapterName, setChapterName] = useState("")
  const query = getRoutesQuery()
  const lang = getLangFromPath()

  useEffect(() => {
    document.body.addEventListener("keyup", e => {
      if (e.which === 9) {
        document.documentElement.classList.remove("no-focus-outline")
      }
    })
  }, [])

  useEffect(() => {
    setChapterName(
      Object.values(query.chapter[lang.toLowerCase()].navigation).filter(
        a => a.route.content === path
      )[0]?.name?.content || ""
    )

    const introPages = ["/pl/", "/en/", "/lt/", "/"]
    if (introPages.find(el => el === path)) {
      setRemoveUI(true)
    } else {
      setRemoveUI(false)
    }
  }, [path])

  const oldBrowser = () => {
    if (typeof window !== "undefined") {
      const userData = window.navigator.userAgent.split(" ")
      const allBrowsers = [
        { name: "Chrome", minVersion: 70 },
        { name: "Firefox", minVersion: 65 },
        { name: "Version", minVersion: 12 },
        { name: "Edge", minVersion: 18 },
        { name: "Trident", minVersion: 8 },
      ]
      const checkBrowser = engineName => {
        return userData.filter(x => {
          return x.includes(engineName)
        })
      }

      let isBrowserOld = false

      allBrowsers.forEach(x => {
        const engine = checkBrowser(x.name)
        if (engine.length > 0) {
          if (parseInt(engine[0].split("/")[1]) < x.minVersion) {
            isBrowserOld = true
          }
        }
      })
      return isBrowserOld
    }
  }

  return (
    <>
      <GlobalStyle />
      <ApplicationWrapper>
        <TransitionProvider
          location={location}
          mode="immediate"
          {...tranistionAnimations("default")}
        >
          <ScrollTransition path={path} />
          <AnimatePresence>
            {!removeUI && (
              <SideBar path={path} routesQuery={query} lang={lang} />
            )}
          </AnimatePresence>
          <main>
            {!oldBrowser() ? (
              <TransitionViews>{children}</TransitionViews>
            ) : (
              <OldBrowser />
            )}
          </main>
          {path.split("/").length > 3 && (
            <SmallTitle>
              <Typography variant="chapterTitle">{chapterName}</Typography>
            </SmallTitle>
          )}
          {!removeUI && (
            <AnimatePresence>
              <ScrollIcon
                path={path}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 1 }}
              />
            </AnimatePresence>
          )}
        </TransitionProvider>
      </ApplicationWrapper>
    </>
  )
}

export default Layout
